import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ChessConsulting = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="max-w-4xl mx-auto px-4 text-center"
    >
      {/* Home Button */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="pt-8 pb-8"
      >
        <Link 
          to="/" 
          className="inline-block bg-gray-800 border border-gray-600 rounded-xl px-6 py-3 text-gray-300 hover:text-gray-100 hover:border-gray-500 transition-all duration-200 font-medium"
        >
          HOME
        </Link>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        <h1 className="text-4xl font-bold text-gray-100 mb-8">
          Chess Consulting Services
        </h1>
        
        <div className="text-gray-300 text-lg leading-relaxed mb-12">
          <p className="mb-6">
            Professional chess website development and digital solutions for the chess community.
          </p>
          <p className="mb-6">
            This TrendingChess.com directory serves as a portfolio showcasing modern chess platform development, 
            featuring responsive design, interactive widgets, and seamless user experiences.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-gray-800/50 backdrop-blur rounded-2xl p-6 border border-gray-700"
          >
            <h3 className="text-xl font-semibold text-gray-100 mb-4">Chess Platform Development</h3>
            <ul className="text-gray-300 text-left space-y-2">
              <li>• Tournament management systems</li>
              <li>• Rating calculators and analytics</li>
              <li>• Interactive chess boards</li>
              <li>• Player databases and directories</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="bg-gray-800/50 backdrop-blur rounded-2xl p-6 border border-gray-700"
          >
            <h3 className="text-xl font-semibold text-gray-100 mb-4">Web Design & UX</h3>
            <ul className="text-gray-300 text-left space-y-2">
              <li>• Responsive mobile-first design</li>
              <li>• Modern dark theme interfaces</li>
              <li>• Smooth animations and transitions</li>
              <li>• Chess community social features</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="bg-gray-800/50 backdrop-blur rounded-2xl p-6 border border-gray-700"
          >
            <h3 className="text-xl font-semibold text-gray-100 mb-4">API Integration</h3>
            <ul className="text-gray-300 text-left space-y-2">
              <li>• Lichess API implementation</li>
              <li>• Chess.com integration</li>
              <li>• Stockfish engine connectivity</li>
              <li>• Real-time game streaming</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="bg-gray-800/50 backdrop-blur rounded-2xl p-6 border border-gray-700"
          >
            <h3 className="text-xl font-semibold text-gray-100 mb-4">Portfolio Example</h3>
            <ul className="text-gray-300 text-left space-y-2">
              <li>• TrendingChess.com directory</li>
              <li>• Widget-based architecture</li>
              <li>• React + TailwindCSS stack</li>
              <li>• Framer Motion animations</li>
            </ul>
          </motion.div>
        </div>

        {/* Contact Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="bg-gray-800/50 backdrop-blur rounded-2xl p-8 border border-gray-700"
        >
          <h3 className="text-2xl font-semibold text-gray-100 mb-4">Get Started</h3>
          <p className="text-gray-300 mb-6">
            Ready to build your chess platform or enhance your existing chess website?
          </p>
          <Link 
            to="/contact"
            className="inline-block bg-blue-600 hover:bg-blue-500 rounded-xl px-8 py-3 text-white font-medium transition-all duration-200"
          >
            Contact for Chess Web Development
          </Link>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default ChessConsulting;